export function decodeSdkJsonValue(value, maxDepth = 4) {
  let decoded = value;
  for (let depth = 0; depth < maxDepth && typeof decoded === 'string'; depth += 1) {
    const trimmed = decoded.trim();
    if (!trimmed || !['{', '[', '"'].includes(trimmed[0])) {
      break;
    }
    try {
      const next = JSON.parse(decoded);
      if (next === decoded) {
        break;
      }
      decoded = next;
    } catch (error) {
      break;
    }
  }
  return decoded;
}

function sdkErrorMessage(error, fallbackMessage) {
  if (!error) {
    return fallbackMessage;
  }
  return error.errMsg || error.message || error.errDlt || fallbackMessage;
}

export function unwrapSdkResponse(response, fallbackMessage) {
  const payload = decodeSdkJsonValue(response);
  if (payload && typeof payload === 'object' && !Array.isArray(payload)) {
    if (typeof payload.errCode !== 'undefined' && Number(payload.errCode) !== 0) {
      throw new Error(sdkErrorMessage(payload, fallbackMessage));
    }
    if (Object.prototype.hasOwnProperty.call(payload, 'data')) {
      return decodeSdkJsonValue(payload.data);
    }
  }
  return payload;
}

export function unwrapSdkMessage(response, fallbackMessage) {
  let message = unwrapSdkResponse(response, fallbackMessage);
  if (Array.isArray(message) && message.length === 1) {
    message = decodeSdkJsonValue(message[0]);
  }
  if (!message || typeof message !== 'object' || Array.isArray(message)) {
    throw new Error(fallbackMessage);
  }
  return message;
}
